<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page" v-else-if="loaded" >
            <div class="col-12 col-md-8 offset-md-2 mt-5" >

                <b-form  @submit.prevent="submit" class="atlass-form col-12 mb-5" >
                    
                    <div class="row no-gutters" v-if="user != null" >
                        
                        <div class="col-12 form-group" >
                            <h3 class="h3 m-0 graymedium-color" > <font-awesome-icon :icon="['far', 'building']" /> 
                                <span v-if="pageType == 'add'" >ADD NEW</span>
                                <span v-else-if="pageType == 'edit'" >EDIT</span>
                                USER 
                            </h3>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label> FIRSTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="user.firstname"
                            required
                            class="form-control"
                            placeholder="Firstname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> LASTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="user.lastname"
                            required
                            class="form-control"
                            placeholder="Lastname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> EMAIL: </label>
                            <b-form-input 
                            type="text"
                            v-model="user.email"
                            required
                            class="form-control"
                            placeholder="Email">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" v-if="pageType == 'add'" >
                            <label> PASSWORD: </label>
                            <b-form-input 
                            type="password"
                            v-model="user.password"
                            required
                            class="form-control"
                            placeholder="Password">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label> ROLE </label>
                            <b-form-select v-model="user.role" class="form-control" :options="roleOptions"></b-form-select>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label> STATUS </label>
                            <b-form-select v-model="user.status" class="form-control" :options="statusOptions"></b-form-select>
                        </div>

                        <div class="col-12 form-group" v-if="( user.role < 2 && userRole < 2 ) || ( user.role >= 2 && userRole <= 2 )" >
                            <b-button type="submit" variant="success" class="btn-sm-w" >Save</b-button>
                            <b-button v-if="pageType == 'edit'" @click="resetPassword" variant="primary" class="btn-sm-w mt-4" >Reset password</b-button>
                            <b-button v-if="pageType == 'edit'" @click="preventDelete" variant="danger" class="btn-sm-w mt-4" >Delete user</b-button>
                        </div>
                        
                    </div>
                </b-form>

            </div> <!-- .col-12 col-md-8 -->
        </div> <!-- .template-page --> 

</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'User',
    props: {
        data: { 
            type: [String, Object, Array],
        },

    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            timeout: 100,
            modalState: false,

            user: null,
            statusOptions:[
                { value: 0, text: 'Inactive' },
                { value: 1, text: 'Active' },
            ],
            roleOptions:[
                { value: 2, text: 'Administrator' },
                { value: 5, text: 'Analyst' },
                //{ value: 9, text: 'User' },
            ],
            pageType: 'edit'
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
                
        if( this.data == null ){
            //new user
            this.user = {
                firstname: '',
                lastname: '',
                email: '',
                role: 5,
                status: 1,
            }
            this.pageType = 'add'
        }else if( typeof this.data == 'string' ){
            //this.data = user id
            this.getUser( this.data )
        }else{
            this.user = this.data
        }
        
        this.loaded = true;
        
    },
    methods: {

        getUser( ID ){
            
            this.$firebase.firestore().collection('users').doc(ID).get()
            .then((snapshot) => {
                    if( snapshot.data() == undefined ){
                        
                        //console.log(this)

                        this.$toast.info({
                            title:'Not found',
                            message: 'User not found'
                        })
                        this.$parent.fModalClose()

                    }else{

                        this.user = snapshot.data()
                        this.user.id = snapshot.id
                            
                    }                     

            })
            
        },
        submit(){
            
            var reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if( !/[a-z]+$/.test(this.user.firstname) ){
                this.$toast.info({
                    title:'Error',
                    message: "Firstname must be valid"
                })
            }else 
            if( !/[a-z]+$/.test(this.user.lastname) ){
                this.$toast.info({
                    title:'Error',
                    message: "Lastname must be valid"
                })
            }else if( !reEmail.test(this.user.email) ){
                this.$toast.info({
                    title:'Error',
                    message: "Email must be a valid email address"
                })
            }else if( this.pageType == 'add' && ( typeof this.user.password !== "string" || this.user.password.length < 6 || /[^A-Za-z0-9]+/g.test(this.user.password) ) ){
                this.$toast.info({
                    title:'Error',
                    message: "Password must contain at least 6 characters"
                })
            }
            else{
                //ALL GOOD
                let params = Cookies.get('user-token')

                //console.log( this.newOrg )
                let data = this.user
                data.APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )

                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }

                let URL = process.env.ROOT_API+'/admin/';
                if( this.pageType == 'add' ){
                    URL += 'add-user'

                    this.$toast.info({
                        title:'Creating user',
                        message: "Please wait"
                    })

                }else{
                    URL += 'edit-user'

                    this.$toast.info({
                        title:'Updating user',
                        message: "Please wait"
                    })

                }

                axios({ method: 'POST', url: URL, headers: headers, data: data })
                .then(resp => {

                    console.log(resp)

                    if( resp.status == 200 ){
                        let r = resp.data;
                        if( r.status == 100 ){

                            setTimeout(function(){ 
                                this.$parent.$parent.getData()
                                this.$parent.fModalClose()
                            }.bind(this), 1500 );

                        }else{
                            this.$toast.info({
                                title:'Error',
                                message: r.data
                            })
                        }
                    }


                })
                .catch(error => {
                    console.log(error)
                }); //end axios 
                //ALL GOOD
            }
                    
            
        },
        
        resetPassword(){
            
            this.$firebase.auth().sendPasswordResetEmail( this.user.email ).then(function() {
                // Email sent.
                let message = 'An email containg the instructions to reset the password has been sent to '+this.user.email
                this.$toast.info({
                    title: 'Reset password',
                    message: message
                })
                //this.submitted = false

            }.bind(this)).catch(function(error) {
                console.log(error)
                // An error happened.
                let message = 'Could not send password reset email. Please reach out to us'
                this.$toast.info({
                    title: 'Reset password',
                    message: message
                })
                
                //this.submitted = false
            }.bind(this));
            
        },
        
        preventDelete(){
            
             this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.deleteUser( );
                    
                }
            })
            
        },
        
        deleteUser(){
            
            let params = Cookies.get('user-token')
            
            //console.log( this.newOrg )
            let data = this.user
            data.APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            let URL = process.env.ROOT_API+'/admin/delete-user';

            axios({ method: 'POST', url: URL, headers: headers, data: data })
                .then(resp => {
                
                console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        setTimeout(function(){ 
                            this.$parent.$parent.getData()
                            this.$parent.fModalClose()
                        }.bind(this), 1500 );
                            
                    }else{
                        this.$toast.info({
                            title:'Error deleting user',
                            message: r.data
                        })
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        }
        
    },
    computed: {
        userRole(){
            return this.$store.getters.getRole
        },
    },
    watch: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    
</style>



// WEBPACK FOOTER //
// src/components/user.vue